export var SliderBreakpointNames;
(function (SliderBreakpointNames) {
    SliderBreakpointNames["Sm"] = "sm";
    SliderBreakpointNames["Md"] = "md";
    SliderBreakpointNames["Lg"] = "lg";
    SliderBreakpointNames["Xl"] = "xl";
})(SliderBreakpointNames || (SliderBreakpointNames = {}));
